import cn from 'clsx'
import useTranslation from 'next-translate/useTranslation'
import Image from 'next/image'
import { InfoLinkIcon } from '@components/icons'
import { useUI } from '@components/ui'
import { sendEvent } from '@lib/tracking'

interface NFTPreviewProps {
  title: string
  description: string
  className?: string
  url?: string
}

export const NFTInformation = ({
  title,
  description,
  className,
  url = '/mystery-owl.png',
}: NFTPreviewProps) => {
  const { t } = useTranslation()
  const { setSidebarView, openSidebar } = useUI()

  return (
    <div className={cn('flex flex-items-stretch items-center', className)}>
      <div className="flex-shrink-0 sm:mr-12 h-16 w-16 sm:h-20 sm:w-20 mx-4 sm:mx-6 relative">
        <Image loading="lazy" src={url} alt="the KNXT NFTs owl head" fill />
      </div>
      <div className="flex flex-col justify-center ml-3 sm:ml-0">
        <p>
          <span className="font-bold text-base">{title}</span>
        </p>
        <p>{description}</p>
      </div>
      <button
        onClick={() => {
          setSidebarView('NFT_INFORMATION_VIEW')
          openSidebar()

          sendEvent({
            event: 'Click_Order_Summary_NFT_Information',
            data: {},
          })
        }}
        className="self-start"
        aria-label={t('checkout:button_nft_information')}
      >
        <InfoLinkIcon />
      </button>
    </div>
  )
}
